/** Path constants (docs/PLAN.md §6 "Ключевые решения фронта") — never hardcode a route string. */
export const ROUTES = {
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verify: '/verify',
  join: (code: string) => `/join/${code}`,

  app: {
    root: '/app',
    join: '/app/join',
    pending: '/app/pending',
    category: (id: string) => `/app/category/${id}`,
    search: '/app/search',
    product: (id: string) => `/app/product/${id}`,
    cart: '/app/cart',
    checkout: '/app/checkout',
    orders: '/app/orders',
    order: (id: string) => `/app/orders/${id}`,
    claims: '/app/claims',
    claim: (id: string) => `/app/claims/${id}`,
    templates: '/app/templates',
    favorites: '/app/favorites',
    balance: '/app/balance',
    profile: '/app/profile',
    addresses: '/app/profile/addresses',
    notificationSettings: '/app/profile/notifications',
    help: '/app/help',
  },
  admin: {
    root: '/admin',
    customers: '/admin/customers',
    customer: (id: string) => `/admin/customers/${id}`,
    staff: '/admin/staff',
    categories: '/admin/categories',
    products: '/admin/products',
    productNew: '/admin/products/new',
    product: (id: string) => `/admin/products/${id}`,
    import: '/admin/import',
    settings: '/admin/settings',
    settingsRequests: '/admin/settings?tab=requests',
    orders: '/admin/orders',
    orderNew: '/admin/orders/new',
    order: (id: string) => `/admin/orders/${id}`,
    stock: '/admin/stock',
    stockProduct: (id: string) => `/admin/stock/products/${id}`,
    batches: '/admin/stock/batches',
    saleNew: '/admin/sales/new',
    documents: '/admin/documents',
    documentNew: '/admin/documents/new',
    document: (id: string) => `/admin/documents/${id}`,
    counterparties: '/admin/counterparties',
    counterparty: (id: string) => `/admin/counterparties/${id}`,
    claims: '/admin/claims',
    claim: (id: string) => `/admin/claims/${id}`,
    payments: '/admin/settings?tab=payments',
    reports: '/admin/settings?tab=reports',
  },
  courier: {
    root: '/courier',
  },
  platform: {
    root: '/platform',
    store: (id: string) => `/platform/stores/${id}`,
  },

  notFound: '/404',
  noAccess: '/no-access',
} as const;
